var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('label',[_vm._v(_vm._s(_vm.$t("NavBar.Midnight")))])]),_c('div',[_c('InputSwitch',{on:{"change":_vm.toggle},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }